import React from "react";
import logo from "./ROLVEDON-Logo-reg.png";

export default function SiteLogo() {
  return <img alt="rolvedon logo. Click here to go to the homepage" src={logo} height="65px" />;
}
